const { firestore } = require("@/config/firebase");

module.exports = {
  getFormattedConversation: (conversation, state, conversationIndex) => {
    let path = "/tenants/" + state.tenant_id + "/users/" + state.owner_id;
    let mute_ids = (conversation.mute_ids) ? conversation.mute_ids : [];
    let isMute = mute_ids.findIndex(a => a === path);
    let status = "active";
    if (!conversation.title) {
      for (let o of (conversation.participants || [])) {
        if (o.user_id !== state.owner_id) {
          status = state.uxDocs[o.user_id] ? state.uxDocs[o.user_id].status : "";
          break;
        }
      }
    }
    const userWriting = conversation.user_writing || {};

    let formatted = {
      chat_id: conversation.chat_id,
      title: conversation.title,
      is_group: !!conversation.title,
      isMute: isMute !== -1,
      icon_url: (conversation.icon_url) ? conversation.icon_url : null,
      last_message: (conversation.last_message) ? {
        ...conversation.last_message,
        date: conversation.last_message.date ? (typeof conversation.last_message.date.toDate === 'function' ? conversation.last_message.date.toDate() : new Date(conversation.last_message.date)) : null,
        date_no: conversation.last_message.date,
        type: conversation.last_message.type,
        content: (conversation.last_message.type !== 'text') ? (conversation.last_message.content ? conversation.last_message.content : "#" + conversation.last_message.type) : conversation.last_message.content,
        sender: conversation.last_message.sender || conversation.sender,
      } : {
        date: null,
      },
      unread_messages_count: (() => {
        if (!conversation.unread_counters) return 0;
        // Try owner_id directly
        if (conversation.unread_counters[state.owner_id] !== undefined) return conversation.unread_counters[state.owner_id];
        // Fallback: extract user_id from participant_ids path and check unread_counters
        const prefix = '/tenants/' + state.tenant_id + '/users/';
        const otherUserIds = (conversation.participants || []).filter(p => p.user_id !== state.owner_id).map(p => p.user_id);
        const ids = (conversation.participant_ids || []).map(p => p.replace(prefix, ''));
        const myId = ids.find(id => !otherUserIds.includes(id));
        return myId ? (conversation.unread_counters[myId] || 0) : 0;
      })(),
      participants: conversation.participants,
      participant_ids: conversation.participant_ids,
      mute_ids: (conversation.mute_ids) ? conversation.mute_ids : [],
      conversation_available: (conversation.conversation_available) ? conversation.conversation_available : [],
      removed_users: (conversation.removed_users) ? conversation.removed_users : [],
      forceRender: conversationIndex !== -1 ? state.conversations[conversationIndex].forceRender + 1 : 0,
      user_writing: userWriting,
      deleted: conversation.deleted ? conversation.deleted : null,
      archived: conversation.deleted ? conversation.archived : null,
      status
    };
    formatted.unread_counters = conversation.unread_counters ? conversation.unread_counters : {};

    return formatted;
  },
  getFormattedMessage: (message, auth_user) => {
    const formattedMessage = {
      type: message.type,
      text: (message.text) ? message.text : ((message.description) ? message.description : ''),
      url: (message.url) ? message.url : '',
      address: (message.address) ? message.address : {},
      invoice: (message.invoice) ? message.invoice : {},
      media: (message.media) ? message.media : {},
      ontheway: (message.ontheway && message.ontheway.latitude) ? {

        address_message_id: message.ontheway.address_message_id,
        description: message.ontheway.description,
        estimated_time_arrival: message.ontheway.estimated_time_arrival && typeof message.ontheway.estimated_time_arrival.toDate === 'function' ? message.ontheway.estimated_time_arrival.toDate() : message.ontheway.estimated_time_arrival,
        latitude: message.ontheway.latitude,
        longitude: message.ontheway.longitude,

      } : {},
      contact: (message.contact) ? message.contact : {},
      event: (message.event && message.event.title) ? {
        title: message.event.title,
        address: message.event.address,
        start_date: message.event.start_date && typeof message.event.start_date.toDate === 'function' ? message.event.start_date.toDate() : message.event.start_date,
        end_date: message.event.end_date && typeof message.event.end_date.toDate === 'function' ? message.event.end_date.toDate() : message.event.end_date,
        notes: message.event.notes,
        status: message.event.status,
        latitude: message.event.latitude,
        longitude: message.event.longitude,
        url: message.event.url,
        answer_status: message.event.answer_status
      } : {},
      update: (message.update) ? message.update : {},
      chat_id: message.chat_id,
      message_id: message.message_id,
      creation_date: (message.creation_date && message.creation_date.toDate) ? message.creation_date.toDate() : message.creation_date,
      sender_id: message.sender_id,
      user_role: message.user_role,
      first_message: message.first_message,
      first_name: message.first_name,
      last_name: message.last_name,
      sending: message.sending,
      sending_status: message.sending_status ? message.sending_status : "success",
      message_identifier: message.message_identifier,
      owner_id: message.owner_id,
      auth_user: (message.sender_id == auth_user),
      read: message.read_statuses ? Object.keys(message.read_statuses).length > 0 : false,
      read_statuses: message.read_statuses || {},
      send: true,
      media_preview_url: message.media_preview_url ? message.media_preview_url : "",
      file: message.file ? message.file : "",
      deleted: message.deleted,
      message_replied: message.message_replied,
      message_replied_data: null,
      is_from_web: message.is_from_web,
      fowarded: message.fowarded,
      reactions: message.reactions ? message.reactions : {},
      reaction_dates: message.reaction_dates ? message.reaction_dates : {},
    };
    return formattedMessage;
  },
  getFormattedMessageForSearch(conversation_ids, message) {
    if (message.sender_id && message.creation_date && (message.description || message.text)) {
      const sender_id_array = message.sender_id.split('/');
      if (conversation_ids.includes(message.chat_id) && sender_id_array.length === 5) {
        message.message_id = message.id;
        message.search = message.description ? message.description.toLowerCase() : message.text.toLowerCase();
        message.text = message.description ? message.description : message.text;
        message.creation_date = message.creation_date.toDate();

        message.search = message.search.replace(/<[^>]*>/g, '').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, "'");

        return message;
      }
    }

    return false;
  },
  async getAllMessagesForConversations(conversationIds, userId, searchText, tenantId) {
    const db = firestore;
    const allDocs = [];
    // Query per-chat messages (batches of 5 to avoid too many parallel reads)
    const batchSize = 5;
    for (let i = 0; i < conversationIds.length; i += batchSize) {
      const batch = conversationIds.slice(i, i + batchSize);
      const promises = batch.map(chatId =>
        db.collection("tenants").doc(tenantId)
          .collection("chats").doc(chatId)
          .collection("messages")
          .orderBy("creation_date", "desc")
          .limit(20)
          .get()
      );
      const results = await Promise.all(promises);
      for (const snap of results) {
        allDocs.push(...snap.docs);
      }
    }
    // Sort by creation_date descending and limit total
    allDocs.sort((a, b) => {
      const dateA = a.data().creation_date;
      const dateB = b.data().creation_date;
      if (!dateA || !dateB) return 0;
      return dateB.toMillis() - dateA.toMillis();
    });
    return allDocs.slice(0, 100);
  },
  async getAllUsersInsideTenant(ownerIds, tenant_id) {
    const db = firestore;
    if (!ownerIds.length) return [];
    if (ownerIds.length <= 10) {
      const snap = await db
        .collection("tenants").doc(tenant_id)
        .collection("users")
        .where("owner_id", "in", ownerIds)
        .get();
      return snap.docs;
    }
    const batches = [];
    for (let i = 0; i < ownerIds.length; i += 10) {
      batches.push(
        db.collection("tenants").doc(tenant_id)
          .collection("users")
          .where("owner_id", "in", ownerIds.slice(i, i + 10))
          .get()
          .catch(error => { console.error(error); return { docs: [] }; })
      );
    }
    const results = await Promise.all(batches);
    return results.flatMap(snap => snap.docs);
  },
  async getAllUsersForTenant(ownerIds) {
    const db = firestore;
    if (!ownerIds.length) return [];
    if (ownerIds.length <= 10) {
      const snap = await db.collection("users")
        .where("owner_id", "in", ownerIds)
        .get();
      return snap.docs;
    }
    const batches = [];
    for (let i = 0; i < ownerIds.length; i += 10) {
      batches.push(
        db.collection("users")
          .where("owner_id", "in", ownerIds.slice(i, i + 10))
          .get()
          .catch(error => { console.error(error); return { docs: [] }; })
      );
    }
    const results = await Promise.all(batches);
    return results.flatMap(snap => snap.docs);
  },
  decodeEntities: text => {
    if (!text) return '';
    return text.replace(/&amp;/g, '&').replace(/&nbsp;/g, ' ').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&#(\d+);/g, (_, n) => String.fromCharCode(n));
  },
  searchContacts: (contacts, owner_id, search) => {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async resolve => {
      let search_results = [];

      let i = 0, len = contacts.length;
      while (i < len) {
        const x = contacts[i];
        if (window.search_status !== 'canceled' &&
          // x.has_logged_into_app &&
          !["super_user", "owner"].includes(x.user_role) &&
          x.owner_id !== owner_id &&
          x.text.startsWith(search)) {
          search_results.push({
            ...x,
            type: "contact",
            category: "Contacts"
          })
        }
        i++;
      }

      resolve(search_results);
    });
  },
  searchConversations: (conversations, user_ids_found, search) => {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async resolve => {
      let search_results = [];
      let i = 0, len = conversations.length;
      while (i < len) {
        const x = conversations[i];
        if (window.search_status !== 'canceled' &&
          x.is_group &&
          (
            x.title.toLowerCase().includes(search) ||
            x.participant_ids.some(y => user_ids_found.includes(y))
          )) {
          search_results.push({
            ...x,
            type: "group",
            category: "Groups"
          })
        }
        i++;
      }

      resolve(search_results);
    })
  },
  searchMessages: (messages, search) => {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async resolve => {
      let search_results = [];
      let i = 0, len = messages.length;
      while (i < len) {
        const message = messages[i];
        if (search_results.length === 50) {
          resolve(search_results);
          return;
        }
        if (message.search && message.search.indexOf(search) !== -1) {
          search_results.push({
            ...message,
            type: "message",
            category: "Messages",
            owner_id: message.sender_id.split('/')[4]
          });
        }
        i++;
      }
      resolve(search_results);
    })
  }
};